module.exports = __webpack_public_path__ + "img/privilege4.d5933a53.png";